import { useEffect } from "react";
import { api, setPermGuard } from "@/lib/api";

const RULES = [
  ["post", /^\/admin\/savings$/, "savings"],
  ["post", /^\/admin\/requests\/[^/]+\/decision$/, "requests"],
  ["post", /^\/admin\/loans\/[^/]+\/decision$/, "loans"],
  ["post", /^\/admin\/registrations\/[^/]+\/approve$/, "registrations"],
  ["post", /^\/admin\/members$/, "members"],
  ["patch", /^\/admin\/members\/[^/]+$/, "members"],
  ["put", /^\/admin\/members\/[^/]+\/pin$/, "members"],
];

export function usePermissionGuard(user) {
  useEffect(() => {
    if (user.role === "superadmin") {
      setPermGuard(null);
      return undefined;
    }
    let perms = null;
    const load = () => api.get("/admin/permissions").then((r) => { perms = r.data; }).catch(() => {});
    load();
    window.addEventListener("cu-admin-changed", load);
    setPermGuard((cfg) => {
      if (!perms) return null;
      const hit = RULES.find(([m, re]) => m === cfg.method && re.test(cfg.url));
      if (!hit) return null;
      const allowed = perms.permissions[hit[2]] || [];
      if (allowed.includes(user.position)) return null;
      return `${perms.actions[hit[2]]} hanya untuk jabatan: ${allowed.length ? allowed.join(", ") : "Super Admin"}`;
    });
    return () => {
      window.removeEventListener("cu-admin-changed", load);
      setPermGuard(null);
    };
  }, [user.role, user.position]);
}
